<template>
	<div class="home">
		<div
			style="
				position: fixed;
				height: 100vh;
				width: 100%;
				background: #fff;
				z-index: 99;
				padding-top: 120px;
			"
		>
			<van-empty image="network" description="正在处理" />
		</div>
		<!--<Header />-->
		<!--<XFixedHeader />-->
		<!--&lt;!&ndash;<XRightFixNav />&ndash;&gt;-->
		<!--<NoticeBar />-->
		<!--&lt;!&ndash;<StudyWeekHeader />&ndash;&gt;-->
		<!--<template v-if="role === 1">-->
		<!--	<MessagePanel />-->
		<!--	<Service />-->
		<!--	<Information />-->
		<!--</template>-->
		<!--<template v-if="role === 2">-->
		<!--	<Service />-->
		<!--	<Information />-->
		<!--	<MessagePanel />-->
		<!--</template>-->
	</div>
</template>
<script setup lang="ts">
import Header from '@/views/pages/home/components/banner.vue'
import NoticeBar from '@/views/pages/home/components/noticeBar.vue'
import StudyWeekHeader from '@/views/pages/home/components/studyWeekHeader.vue'
import MessagePanel from '@/views/pages/home/components/messagePanel.vue'
import Service from '@/views/pages/home/components/service.vue'
import Information from '@/views/pages/home/components/information.vue'
import XFixedHeader from '@/components/XFixedHeader.vue'
import XRightFixNav from '@/components/XRightFixNav.vue'
import { useAuthStore } from '@/store/auth'
import getNativeInstance from '@/utils/JSBridge'
import { openWebview } from '@/utils'
import { useRememberScroll } from '@/hooks/remeberScroll'

const role = ref(1) // 1教师，2学生

provide('role', role)

useRememberScroll()

onMounted(() => {
	const userStore = useAuthStore()
	if (['BKS', 'YJS'].includes(userStore.userInfo.F_QuickQuery)) {
		role.value = 2
	}
	if (['JZG'].includes(userStore.userInfo.F_QuickQuery)) {
		role.value = 1
	}
	checkUpdate()
})

onActivated(() => {
	hideStatusBar()
})

const hideStatusBar = () => {
	if (window.UniAppJSBridge) {
		getNativeInstance().customInvoke({
			action: 'setAppStatusBar',
			data: {
				visible: false
			}
		})
	}
}

const checkUpdate = () => {
	if (window.UniAppJSBridge) {
		getNativeInstance().customInvoke({
			action: 'checkAppUpdate',
			data: {
				type: 0
			}
		})
	}
}
</script>

<style scoped lang="scss">
.home {
	overflow-y: auto;
	min-height: 100vh;
	background-color: #f4f3f3;
	padding-bottom: 60px;
	&::-webkit-scrollbar {
		display: none;
	}
}
</style>
